import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ViewOrUpdatePaymentMethodsCTA } from "./ctas";

export const BillingAddressIA: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },

  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => UPDATE_BILLING_ADDRESS(strictLocalize),
    getDescription: () => [
      TO_UPDATE_PAYMENT_METHOD_BILLING_ADDRESS(strictLocalize),
      TO_CHANGE_ADDRESS_ON_PAID_INVOICES(strictLocalize),
    ],
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return ViewOrUpdatePaymentMethodsCTA(strictLocalize);
};

const UPDATE_BILLING_ADDRESS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Update billing address",
    description: {
      text: "Title for the answer of What is EORI number issue",
    },
  });

const TO_UPDATE_PAYMENT_METHOD_BILLING_ADDRESS = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "A billing address is associated with each saved payment method. To update, go to “Payment methods” in your “Account settings” and find the payment method you’d like to change. Select “Edit” beside the billing address, and you can select from previously used addresses or add a new one. If you update the billing address for a payment method, it will change on all unpaid invoices using that method.",
  });

const TO_CHANGE_ADDRESS_ON_PAID_INVOICES = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "To change the address on paid invoices, go to the invoice you want to update and choose “Edit address”. You can select from previously used addresses or add a new address to apply to the invoice. When you modify paid invoices, you’ll need to edit each one separately. Making changes will not affect the billing address on your associated payment method.",
  });
